<app-header-one [sticky]="true"></app-header-one>
<h2 class="section-title" style="color: #cfcfcf;">Plans and Prices</h2>
<mat-tab-group>
  <mat-tab *ngFor="let moduleName of moduleNames">

    <ng-template mat-tab-label class="abc">
      <span style="text-transform: uppercase;"> {{ planLabels[moduleName] }} </span>
      <!-- <div style="color: #BF0000;">EMPLOYMENT</div> -->

      <i class="ti ti-user-circle"></i>
    </ng-template>
    <section class="plans-section section-b-space">
      <div class="container">
        <div class="row">
          <div class="col-md-3" *ngFor="let job of modules[moduleName]; let i = index">
            <div class="job-card">
              <div class="header">
                <h2 class="company-name">{{ job.plan_title }}</h2>
                <sub>{{ job.plan_description }}</sub>
              </div>
              <div class="content">

                <p class="plan-price"> <sup *ngIf="job.offer_applicable==='Y'"><del>&#8377;{{ job.plan_price
                      }}</del></sup> &#8377;{{ job.sub_total }}/<span style="font-size: 0.60rem;">{{
                    job.plan_days_label }}</span></p>
                <!-- <p class="plan-days">Plan Period: {{ job.plan_days }}</p> -->
                <ul>

                  

                  <!-- <li *ngFor="let subPlan of job.plans" class="plan-item">
                    <div class="checkbox-wrapper">
                      <i class="fa-regular fa-square-check"></i>&nbsp;
                      <p class="checkbox-container" [innerHTML]="transformDescription(subPlan.description)"></p>
                    </div>
                  </li> -->
                  <!-- <li class="plan-item"> -->

                    <li class="plan-item" style="padding-bottom: 3% !important;">
                      <i class="fa-regular fa-square-check"></i>&nbsp;Duration :&nbsp;<strong style="color: #5f4bde;">{{ job.plan_days}}</strong>&nbsp;days
                      </li>

                    <!-- <li class="plan-item" style="padding-bottom: 3% !important;">
                      <i class="fa-regular fa-square-check"></i>&nbsp;
                      <p class="checkbox-container">Duration : <strong>{{ job.plan_days}}</strong>&nbsp;days</p>
                    </li> -->

                    <!-- <div class="checkbox-wrapper">
                      <i class="fa-regular fa-square-check"></i>&nbsp;
                     
                       <p class="checkbox-container">Extra <strong> {{ job.grace_days}}</strong>&nbsp;days</p> 
                    </div> -->

                  <!-- </li> -->

                  @if(job.module_name === 'MATRI_VENDOR'){
                  <li class="plan-item" style="padding-bottom: 3% !important;">
                    <i class="fa-regular fa-square-check"></i>&nbsp;Post <strong style="color: #5f4bde;">&nbsp;{{ job.no_of_volumes }}&nbsp;</strong>Profiles 
                  </li>
                  <!-- <li class="plan-item" style="padding-bottom: 3% !important;">
                    <i class="fa-regular fa-square-check"></i>&nbsp;

                    Extra profiles : <strong>&nbsp; {{ job.extra_volumes }}</strong>


                  </li> -->
                  <li class="plan-item" style="padding-bottom: 3% !important;">
                    <i class="fa-regular fa-square-check"></i>&nbsp; Post<strong style="color: #5f4bde;">&nbsp;{{ job.premium_volumes }}&nbsp;</strong> Premium profiles
                  </li>
                  <li class="plan-item" style="padding-bottom: 3% !important;">
                    <i class="fa-regular fa-square-check"></i>&nbsp;View contact &nbsp;<strong style="color: #5f4bde;">{{ job.max_contacts}}&nbsp;</strong>numbers 
                  </li>
                  <li class="plan-item" style="padding-bottom: 3% !important;">
                    <i class="fa-regular fa-square-check"></i>&nbsp;View <strong style="color: #5f4bde;"> &nbsp;{{job.max_profile_views}}&nbsp;</strong> Profiles
                  </li>
                  <!-- <li class="plan-item" > 
                            <i class="fa-regular fa-square-check"></i>&nbsp;Daily watch upto : <strong> &nbsp; {{ job.daily_view_limit}} </strong></li> -->
                  <li class="plan-item" style="padding-bottom: 3% !important;">
                    <i class="fa-regular fa-square-check"></i>&nbsp;Express &nbsp;<strong style="color: #5f4bde;">{{job.max_profile_interests}}&nbsp;</strong> interests
                  </li>
                  <li class="plan-item" style="padding-bottom: 3% !important;">
                    <i class="fa-regular fa-square-check"></i>&nbsp;Shortlist &nbsp;<strong style="color: #5f4bde;"> {{ job.max_profile_shortlists}}&nbsp;</strong> profiles
                  </li>
                  <li class="plan-item" style="padding-bottom: 3% !important;">
                    <i class="fa-regular fa-square-check"></i>&nbsp;Visit <strong style="color: #5f4bde;">&nbsp; {{
                      job.max_premium_profile_visits}}&nbsp;</strong>Premium profiles
                  </li>

                  <li class="plan-item" style="padding-bottom: 3% !important;" *ngFor="let subPlan of job.plans">
                    <!-- <i class="fa-regular fa-square-check"></i>&nbsp; -->
                    <i [innerHTML]="transformDescription(subPlan.description)"></i>
                  </li>

                  }
                  @else if(job.module_name === 'JOBS'){
                  <li class="plan-item">
                    <i class="fa-regular fa-square-check"></i>&nbsp;
                    No of job postings : <strong>&nbsp; {{ job.no_of_volumes }}</strong>
                  </li>
                  <li class="plan-item">
                    <i class="fa-regular fa-square-check"></i>&nbsp;
                    No of extra vol : <strong>&nbsp; {{ job.extra_volumes }}</strong>
                  </li>
                  <li class="plan-item">
                    <i class="fa-regular fa-square-check"></i>&nbsp;
                    No of premium vol : <strong>&nbsp; {{ job.premium_volumes }}</strong>
                  </li>
                 

                  }
                  @else if(job.module_name === 'JOBS_DB'){
                  <li class="plan-item">
                    <i class="fa-regular fa-square-check"></i>&nbsp;
                    No of job seekers : <strong>&nbsp; {{ job.no_of_volumes }}</strong>
                  </li>
                  <li class="plan-item">
                    <i class="fa-regular fa-square-check"></i>&nbsp;
                    No of extra vol : <strong>&nbsp; {{ job.extra_volumes }}</strong>
                  </li>
                  <li class="plan-item">
                    <i class="fa-regular fa-square-check"></i>&nbsp;
                    No of premium vol : <strong>&nbsp; {{ job.premium_volumes }}</strong>
                  </li>
                 

                  }
                  @else if(job.module_name === 'ADVERTS'){
                  <li class="plan-item">
                    <i class="fa-regular fa-square-check"></i>&nbsp;
                    No of advertisements : <strong>&nbsp; {{ job.no_of_volumes }}</strong>
                  </li>

                  <li class="plan-item">
                    <i class="fa-regular fa-square-check"></i>&nbsp;
                    No of extra vol : <strong>&nbsp; {{ job.extra_volumes }}</strong>
                  </li>
                  <li class="plan-item">
                    <i class="fa-regular fa-square-check"></i>&nbsp;
                    No of premium vol: <strong>&nbsp; {{ job.premium_volumes }}</strong>
                  </li>
                 

                  }



                  <!-- @else {
                      <li class="plan-item"> 
                        <i class="fa-regular fa-square-check"></i>&nbsp;
                        Extra volumes : <strong>&nbsp; {{ job.extra_volumes }}</strong>
                        </li>
                    
                    } -->
                  <!-- <li class="plan-item">
                      <i class="fa-regular fa-square-check"></i>&nbsp;
                        Premium volumes : <strong>&nbsp; {{ job.premium_volumes }}</strong>
                      </li> -->



                </ul>

              </div>

              <div class="button-container">
                <button type="submit" class="btn button-text" (click)="goTo(job)">Get it now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </mat-tab>
</mat-tab-group>


<app-footer-one></app-footer-one>